require('../../../../node_modules/normalize.css/normalize.css');
require('../../../assets/css/main.scss');
require('./cookie-policy.scss');

window.onscroll = () => {
  let t = void 0 !== window.pageYOffset ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
  const header = document.getElementsByTagName('header')[0];
  header.style.backgroundColor = 'rgba(255, 255, 255, ' + Math.min(1, t / 100) + ')';
};
